import React, { useState, useEffect, useRef } from "react"
import '../../assets/css/views/activities/esfCoverage.css'
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Modal, ButtonGroup, TextArea, Card, RadioButtons, RadioButton, IconChevronDown, ListItem, IconChevronRight, Select, SelectOption, Tooltip, IconInfo, IconCheckmarkCircle } from "@veneer/core";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import BackButton from "../../features/path/backButton";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import esfCoverageService from "../../services/agendaApi/esfCoverage.service";
import { IAppointmentDto } from "../../models/dto/agendaApi/IAppointmentDto";
import appointmentService from "../../services/agendaApi/appointment.service";
import salesService from "../../services/agendaApi/sales.service";
import { IBrandDto } from "../../models/dto/agendaApi/IBrandDto";
import { IEsfCoverageAdvisorDetailsTemp, IEsfCoverageAdvisorTemp, IEsfCoverageDto, IEsfCoverageLovDto, IEsfCoverageTemp, IEsfCoverageTypeDto } from "../../models/dto/generalApi/IEsfCoverageDto";
import { IEsfCoverageDetails, IEsfCoverageIn } from "../../models/input/generalApi/IEsfCoverageIn";




export default function EsfCoverage() {

  const params = useParams();
  const [t] = useTranslation("global");
  const languageId: any = useSelector((state: RootState) => state.languageId);
  type SelectValue = number | string | boolean; //CHECK
  const navigate = useNavigate();

  const actualPosCode = useRef('');
  const isFirstRender = useRef(true);

  const [appointmentActivityId, setAppointmentActivityId] = useState(NaN);
  const [activityId, setActivityId] = useState(NaN);

  //Data
  const [brands, setBrands] = useState<IEsfCoverageTemp[]>([]);
  const [advisorsData, setAdvisorsData] = useState<IEsfCoverageAdvisorTemp[]>([]);
  const [optionsAdvisors, setOptionsAdvisors] = useState<SelectOption[]>([]);
  const [optionsDays, setOptionsDays] = useState<SelectOption[]>([]);
  const [optionsHours, setOptionsHours] = useState<SelectOption[]>([]);
  const [validations, setValidations] = useState<any[]>([]);


  const [saveDisable, setSaveDisable] = useState(true);


  useEffect(() => {
    getPosCode()
    let id = Number(params.id);
    let activityId = Number(params.activityId);
    setActivityId(id)
    setAppointmentActivityId(activityId);
  }, [])

  useEffect(() => {
    let validation = brands.map((brand, index) => {
      if (brand.esfCoverageDetails[0].quantity.length !== 0 && brand.esfCoverageDetails[1].quantity.length !== 0) {
        if (brand.esfCoverageDetails[0].quantity[1] === 0) {
          return { 'brandId': brand.brandID, 'status': 1 }
        } else {
          let actualAdvisor = advisorsData.find(item => item.brandID === brand.brandID);
          if (actualAdvisor?.advisorDetails.find(detail => detail.days.length === 0 || detail.hours.length === 0)) {
            return { 'brandId': brand.brandID, 'status': 2 }
          } else {
            return { 'brandId': brand.brandID, 'status': 1 }
          }
        }
      } else if (brand.esfCoverageDetails[0].quantity.length !== 0 || brand.esfCoverageDetails[1].quantity.length !== 0) {
        return { 'brandId': brand.brandID, 'status': 2 }
      } else {
        return { 'brandId': brand.brandID, 'status': 3 }
      }
    })
    setValidations(validation)
    if (validation.some(item => item.status === 1) && !validation.find(item => item.status === 2)) {
      setSaveDisable(false)
    } else {
      setSaveDisable(true)
    }
  }, [brands, advisorsData])

  useEffect(() => {
    if (isFirstRender.current && brands.length !== 0 && optionsAdvisors.length !== 0 && optionsDays.length !== 0 && optionsHours.length !== 0) {
      getEsfCoverage()
      isFirstRender.current = false;
    }
  }, [brands, optionsAdvisors, optionsDays, optionsHours])


  const getEsfCoverage = () => {
    esfCoverageService.getEsfCoverage()
      .then(r => {
        fillInfoEsfCoverage(r)
      });

  }

  const getPosCode = () => {
    let id = Number(params.id);
    let appointmentResponse: IAppointmentDto[] = [];
    appointmentService.getAppointmentByUser()
      .then(r => {
        appointmentResponse = r;
      }).finally(() => {
        let posCode = appointmentResponse.find(x => x.appointmentId === id)?.posCode;
        if (posCode) {
          actualPosCode.current = posCode;
          getData(posCode);
        } else { alert("Error") }

      })
  }

  const getData = (posCode: string) => {
    esfCoverageService.getEsfCoverageType(languageId.value).then(responseType => {
      salesService.getBrandsByPos(posCode).then(brands => {
        const brandsFiltered = brands.filter((item:any) => item.brandID !== 1)
        fillBrands(brandsFiltered, responseType);
      });
    }).then(() => {
      esfCoverageService.getEsfCoverageLov().then(r => {
        fillOptions(r)
      })
    })
  }

  const fillBrands = (data: IBrandDto[], responseType: IEsfCoverageTypeDto[]) => {
    const brandsTemp: IEsfCoverageTemp[] = [];
    for (let i = 0; i < data.length; i++) {
      const brand: IBrandDto = data[i];
      let brandTemp: IEsfCoverageTemp;
      brandTemp = {
        'brandID': brand.brandID,
        'brandName': brand.brandName,
        'esfCoverageDetails': responseType.map((item: IEsfCoverageTypeDto) => {
          return {
            typeID: item.esF_CoverageTypeID,
            label: item.label,
            quantity: [],
            days: [],
            hours: []
          }
        })

      }
      brandsTemp.push(brandTemp);
    }
    setBrands(brandsTemp);

  }

  const fillOptions = (data: IEsfCoverageLovDto[]) => {
    const advisorsTemp: SelectOption[] = [];
    const daysTemp: SelectOption[] = [];
    const hoursTemp: SelectOption[] = [];
    for (let i = 0; i < data.length; i++) {
      const item: IEsfCoverageLovDto = data[i];
      let itemTemp: SelectOption;
      itemTemp = {
        'value': item.value,
        'label': String(item.value),
      }
      if (item.field === "QUANTITY") {
        advisorsTemp.push(itemTemp);
      } else if (item.field === "DAYS") {
        daysTemp.push(itemTemp);
      } else if (item.field === "HOURS") {
        hoursTemp.push(itemTemp);
      }
      else {
      }
    }
    setOptionsAdvisors(advisorsTemp);
    setOptionsDays(daysTemp);
    setOptionsHours(hoursTemp);
  }


  const fillInfoEsfCoverage = (data: IEsfCoverageDto[]) => {
    data.filter(datas => datas.poS_Code === actualPosCode.current).map((data, indexItem) => {
      if (data.esF_CoverageTypeID === 1) {
        let brandsTemp = brands;
        let indexActual = brandsTemp.findIndex(item => item.brandID == data.brandID);
        let item = brandsTemp[indexActual].esfCoverageDetails.find(detail => detail.typeID == data.esF_CoverageTypeID);
        if (item) {
          item!.quantity = [data.quantity];
        }
        setBrands([...brandsTemp])

      } else if (data.esF_CoverageTypeID === 2) {

        let brandsTemp = brands;
        let indexActual = brandsTemp.findIndex(item => item.brandID == data.brandID);
        let item = brandsTemp[indexActual].esfCoverageDetails.find(detail => detail.typeID == data.esF_CoverageTypeID);
        if (item) {
          item!.quantity = [Number(item.quantity) + data.quantity];
        }
        setBrands([...brandsTemp])
        handleChangeChargeAdvisor(data.brandID, data.days, data.hours)



      }

    })

  }

  const handleChangeChargeAdvisor = (brandID: number, days: number, hours: number) => {
    let advisorDataTemp = advisorsData;
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);
    if (itemActual) {
      let details: IEsfCoverageAdvisorDetailsTemp[] = itemActual.advisorDetails;

      details.push({
        days: [days],
        hours: [hours]
      })
      advisorDataTemp.find(item => item.brandID == brandID)!.advisorDetails = details;
      setAdvisorsData([...advisorDataTemp])
    } else {
      let newItem: IEsfCoverageAdvisorTemp;
      let newDetails: IEsfCoverageAdvisorDetailsTemp[] = [{
        days: [days],
        hours: [hours]
      }];

      newItem = {
        'brandID': brandID,
        'advisorDetails': newDetails
      }
      advisorDataTemp.push(newItem);
      setAdvisorsData([...advisorDataTemp])

    }


  }


  const handleChangeSelectFixed = (value: SelectValue, brandID: number, typeID: number) => {
    let brandsTemp = brands;
    let indexActual = brandsTemp.findIndex(item => item.brandID == brandID);
    let item = brandsTemp[indexActual].esfCoverageDetails.find(detail => detail.typeID == typeID);
    if (item) {
      item!.quantity = [value];
    }
    setBrands([...brandsTemp])


  }

  const handleChangeClear = (brandID: number, typeID: number) => {
    let brandsTemp = brands;
    let advisorDataTemp = advisorsData;

    let indexActual = brandsTemp.findIndex(item => item.brandID == brandID);
    let item = brandsTemp[indexActual].esfCoverageDetails.find(detail => detail.typeID == typeID);
    if (item) {
      item!.quantity = [];
    }
    if (typeID === 2) {
      advisorDataTemp = advisorDataTemp.filter(item => item.brandID !== brandID);
      setAdvisorsData([...advisorDataTemp])
    }

    setBrands([...brandsTemp])
  }


  const handleChangeSelectRotary = (value: SelectValue, brandID: number, typeID: number) => {
    let brandsTemp = brands;
    let indexActual = brandsTemp.findIndex(item => item.brandID == brandID);
    let item = brandsTemp[indexActual].esfCoverageDetails.find(detail => detail.typeID == typeID);
    if (item) {
      item!.quantity = [value];
    }
    setBrands([...brandsTemp])
    handleChangeAdvisorData(brandID, Number(value));

  }

  const handleChangeSelectDays = (value: SelectValue, brandID: number, index: number) => {
    let advisorDataTemp = advisorsData;
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);
    if (itemActual) {
      itemActual!.advisorDetails[index].days = [value];
      setAdvisorsData([...advisorDataTemp])
    }
  }

  const handleChangeOnClearDays = (brandID: number, index: number) => {
    let advisorDataTemp = advisorsData;
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);
    if (itemActual) {
      itemActual!.advisorDetails[index].days = [];
      setAdvisorsData([...advisorDataTemp])
    }
  }

  const handleChangeSelectHours = (value: SelectValue, brandID: number, index: number) => {
    let advisorDataTemp = advisorsData;
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);
    if (itemActual) {
      itemActual!.advisorDetails[index].hours = [value];
      setAdvisorsData([...advisorDataTemp])
    }
  }

  const handleChangeOnClearHours = (brandID: number, index: number) => {
    let advisorDataTemp = advisorsData;
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);
    if (itemActual) {
      itemActual!.advisorDetails[index].hours = [];
      setAdvisorsData([...advisorDataTemp])
    }
  }


  const handleChangeAdvisorData = (brandID: number, value: number) => {
    let advisorDataTemp = advisorsData;
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);

    if (itemActual) {
      if (Number(value) === 0) {
        advisorDataTemp = advisorDataTemp.filter(item => item.brandID !== itemActual?.brandID);
        setAdvisorsData([...advisorDataTemp])
      } else {
        if (Number(value) > itemActual.advisorDetails.length) {
          let difference = Number(value) - itemActual.advisorDetails.length;
          let details: IEsfCoverageAdvisorDetailsTemp[] = itemActual.advisorDetails;
          for (let i = 0; i < difference; i++) {
            details.push({
              days: [],
              hours: []
            })
          }
          advisorDataTemp.find(item => item.brandID == brandID)!.advisorDetails = details;
          setAdvisorsData([...advisorDataTemp])

        } else if (Number(value) < itemActual.advisorDetails.length) {
          let difference = itemActual.advisorDetails.length - Number(value);
          let details: IEsfCoverageAdvisorDetailsTemp[] = itemActual.advisorDetails;
          for (let i = 0; i < difference; i++) {
            details.pop()
          }
          advisorDataTemp.find(item => item.brandID == brandID)!.advisorDetails = details;
          setAdvisorsData([...advisorDataTemp])

        }
      }
    } else {
      if (Number(value) !== 0) {
        let newItem: IEsfCoverageAdvisorTemp;
        let newDetails: IEsfCoverageAdvisorDetailsTemp[] = [];
        for (let i = 0; i < value; i++) {
          newDetails.push({
            days: [],
            hours: []
          })
        }
        newItem = {
          'brandID': brandID,
          'advisorDetails': newDetails
        }
        advisorDataTemp.push(newItem);
        setAdvisorsData([...advisorDataTemp])
      }
    }
  }


  const onSaveEsfCoverage = () => {
    let esfCoverageIn: IEsfCoverageIn[] = [];
    let esfCoverageDetailsTemp: IEsfCoverageDetails[] = [];

    let date = new Date()
    for (let i = 0; i < brands.length; i++) {
      let esfCoverageDetailsIn: IEsfCoverageDetails[] = [];

      let brandTemp = brands[i];
      let detailsTemp = brands[i].esfCoverageDetails;
      detailsTemp.map((detail, indexDetails) => {
        if (detail.quantity.length !== 0) {
          if (detail.typeID === 2) {
            let advisorDataTemp = advisorsData.find(data => data.brandID === brandTemp.brandID);
            advisorDataTemp!.advisorDetails.map((data, indexData) => {
              esfCoverageDetailsIn.push({
                brandID: brandTemp.brandID,
                typeID: detail.typeID,
                quantity: 1,
                days: Number(data.days),
                hours: Number(data.hours)
              })
            })
          } else {
            esfCoverageDetailsIn.push({
              brandID: brandTemp.brandID,
              typeID: detail.typeID,
              quantity: Number(detail.quantity),
              days: Number(detail.days),
              hours: Number(detail.hours)
            })

          }
        }
      })

      if (esfCoverageDetailsIn.length !== 0) {
        esfCoverageDetailsIn.map((details, index) => { esfCoverageDetailsTemp.push(details) })
      }

    }

    esfCoverageIn.push({
      appointmentActivityID: appointmentActivityId,
      dateTime: date.toISOString(),
      esfCoverageDetails: esfCoverageDetailsTemp,
    })

    console.log(esfCoverageIn)
    esfCoverageService.insertEsfCoverage(esfCoverageIn)
      .then(r => {
        console.log(r)
        isFirstRender.current = true;
        setBrands([])
        setAdvisorsData([])
        getData(actualPosCode.current)
      })

  }







  return (
    <>
      <div className="esfCoverage">
        <BackButton route={BreadCrumbsEnum.ESFCoverage} activityId={activityId} appointmentActivityId={appointmentActivityId} />
        <h4 className="esfCoverageTitle">{t("header.esfCoverageTitle")}</h4>

        <Card
          appearance="outlined"
          className="esfCoverageRegisterInformation"
          content={<>
            {
              brands.map((brand, index) => {
                return (
                  <Accordion
                    key={brand.brandName}
                    className="esfCoverageAccordion"
                  >
                 
                    <AccordionSummary
                      expandIcon={<IconChevronDown />}
                      aria-controls="panel2a-content"
                      id="panel2a-header">
                      {brand.brandName}&nbsp;&nbsp;
                      {
                        validations.find(item => item.brandId === brand.brandID)?.status === 1
                          ?
                          <IconCheckmarkCircle color="colorLightGreen6" filled></IconCheckmarkCircle>
                          :
                          null
                      }
                    </AccordionSummary>

                    <AccordionDetails>
                      {brand.esfCoverageDetails.map((details, indexDetails) => {

                        if (details.typeID === 1) {
                          return (
                            <ListItem className="esfCoverageListItem" key={"details" + indexDetails} id={String(indexDetails)}
                              leadingArea={
                                <Tooltip
                                  placement="trailing"
                                  content={t("header.messageFixed")}
                                  id="tooltip"
                                ><div className="esfCoverageIconInfo"><IconInfo /><p>{t("header.fixedEsf")}</p></div></Tooltip>
                              }
                              trailingArea={
                                <Select
                                  className="esfCoverageSelect"
                                  options={optionsAdvisors}
                                  label={t("header.numberAdvisors")}
                                  placement="bottom"
                                  onChange={e => handleChangeSelectFixed(e.value, brand.brandID, details.typeID)}
                                  onClear={() => handleChangeClear(brand.brandID, details.typeID)}
                                  value={details.quantity}
                                />
                              } />

                          )

                        } else if (details.typeID === 2) {
                          return (
                            <>
                              <ListItem className="esfCoverageListItem" key={"details" + indexDetails} id={String(indexDetails)}
                                leadingArea={
                                  <Tooltip
                                    placement="trailing"
                                    content={t("header.messageRotary")}
                                    id="tooltip"
                                  ><div className="esfCoverageIconInfo"><IconInfo /><p>{t("header.rotaryEsf")}</p></div></Tooltip>
                                }
                                trailingArea={
                                  <Select
                                    className="esfCoverageSelect"
                                    options={optionsAdvisors}
                                    label={t("header.numberAdvisors")}
                                    placement="bottom"
                                    onChange={e => handleChangeSelectRotary(e.value, brand.brandID, details.typeID)}
                                    onClear={() => handleChangeClear(brand.brandID, details.typeID)}
                                    value={details.quantity}
                                  />
                                } />

                              {details.quantity.length != 0 ?

                                advisorsData.filter(item => item.brandID === brand.brandID).map((advisor, indexAdvisor) => {
                                  return (
                                    advisor.advisorDetails.map((advisorDetails, indexAdvisorDetails) => {
                                      return (
                                        <ListItem className="esfCoverageListItemDetails" key={indexAdvisorDetails} id={String(indexAdvisorDetails)}
                                          leadingArea={<p>{t("header.advisor")}{" " + (indexAdvisorDetails + 1)}</p>}
                                          trailingArea={
                                            <div className="esfCoverageSelectsDetails">
                                              <div>
                                                <p>{t("header.averageDays")}</p>
                                                <Select
                                                  className="esfCoverageSelectDetails"
                                                  options={optionsDays}
                                                  placement="bottom"
                                                  onChange={e => handleChangeSelectDays(e.value, brand.brandID, indexAdvisorDetails)}
                                                  onClear={() => handleChangeOnClearDays(brand.brandID, indexAdvisorDetails)}
                                                  value={advisorDetails.days}
                                                />
                                              </div>
                                              <div>
                                                <p>{t("header.averageHours")}</p>
                                                <Select
                                                  className="esfCoverageSelectDetails"
                                                  options={optionsHours}
                                                  placement="bottom"
                                                  onChange={e => handleChangeSelectHours(e.value, brand.brandID, indexAdvisorDetails)}
                                                  onClear={() => handleChangeOnClearHours(brand.brandID, indexAdvisorDetails)}
                                                  value={advisorDetails.hours}
                                                />
                                              </div>
                                            </div>
                                          } />
                                      )

                                    })

                                  )
                                })

                                : null
                              }


                            </>
                          )
                        } else {
                          return null
                        }

                      })
                      }

                    </AccordionDetails>

                  </Accordion>
                )
              })

            }
          </>}
        />

        <div className="closingSalesSaveButton">
          <Button onClick={onSaveEsfCoverage} disabled={saveDisable}>{t("header.save")}</Button>
        </div>




      </div>
    </>
  );
}